<ng-container *transloco="let t">
  @if (isOpen()) {
    <ld-base-modal
      [title]="t('chunkErrorDialogTitle')"
      [showCloseButton]="false"
      [closeOnBackdropClick]="false"
      [critical]="true"
      [ariaLabelledBy]="'chunk-error-dialog-title'"
    >
      <div modal-content>
        <div id="chunk-error-dialog-icon" class="pb-4 flex justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-12 h-12 text-ld-primary"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </div>

        <p id="chunk-error-dialog-message" class="text-ld-neutral-600 text-center">
          {{ t('chunkErrorDialogMessage') }}
        </p>
      </div>

      <div modal-footer>
        <button
          id="chunk-error-dialog-refresh-button"
          type="button"
          class="btn-primary-ld-purple"
          (click)="onRefresh()"
        >
          {{ t('chunkErrorDialogRefreshButton') }}
        </button>
      </div>
    </ld-base-modal>
  }
</ng-container>
